export const telemetryActions = {
  appChange: "app-change"
};
